import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Mediaclip } from '../../../interfaces/mediaclip';
import { BbReactComponent } from 'app/components/shared/bb-react/bb-react.component';

@Component({
	selector: 'mediaclip-details-react',
	templateUrl: './mediaclip-details-react.component.html'
})
export class MediaclipDetailsReactComponent implements OnInit {
	@Input() mediaclip: Mediaclip;
	@Input() isActive: boolean;
	@Input() form: NgForm;

	@ViewChild(BbReactComponent) reactComponent: BbReactComponent;

	entity: Mediaclip;

	constructor() {
	}

	ngOnInit() {
		this.entity = this.mediaclip;
	}

	// cancel from bb action bar
	cancel(): void {
		this.reactComponent.cancel();
	}
}
